import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_FONMAPS, FETCH_FONMAP, FONMAP_REMOVE, FONMAP_SAVE, FONMAPS_LIST_SAVE, FETCH_ERROR } from './actions.type'
import { SET_FONMAPS, SET_FONMAPS_ERRORS, SET_FONMAPS_LOADING, SET_FONMAP, SET_FONMAP_ERRORS, SET_FONMAP_LOADING, SET_FONMAPS_LIST_LOADING } from './mutations.type'

const state = {
	fonMaps: [],
	fonMapsErrors: [],
	fonMapsIsLoading: false,
	fonMap: null,
	fonMapErrors: [],
	fonMapIsLoading: false,
	fonMapsListIsLoading: false
}

const getters = {
	fonMaps:state => key => {
			return state.fonMaps.filter(x => x.name.toLowerCase().includes(key.toLowerCase())).sort(function(a,b) { return a.orderfm - b.orderfm })
	},
	fonMapsErrors (state) {
		return state.fonMapsErrors
	},
	fonMapsIsLoading (state) {
		return state.fonMapsIsLoading
	},
	fonMap (state) {
		return state.fonMap
	},
	fonMapErrors (state) {
		return state.fonMapErrors
	},
	fonMapIsLoading (state) {
		return state.fonMapIsLoading
	},
	fonMapsListIsLoading (state) {
		return state.fonMapsListIsLoading
	}
}

const actions = {
	[FETCH_FONMAPS] (context, params) {
		context.commit(SET_FONMAPS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/fonmaps')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_FONMAPS, data)
					resolve(data)
				} else {
					context.commit(SET_FONMAPS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_FONMAPS_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_FONMAPS_LOADING, false)
			})
		})
	},
	[FETCH_FONMAP] (context, params) {
		context.commit(SET_FONMAP_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy('manager/fonmaps', params.id)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_FONMAP, data)
					resolve(data)
				} else {
					context.commit(SET_FONMAP_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_FONMAP_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_FONMAP_LOADING, false)
			})
		})
	},
	[FONMAP_SAVE] (context, params) {
		context.commit(SET_FONMAP_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/fonmaps/${params.id}`, params)
			.then(({data}) => {
				if (data) {
					if (data === true) {
						this.dispatch(FETCH_ERROR, { variant: "success", text: "Подложка сохранена", title: "Готово" })
					}
					else {
						this.dispatch(FETCH_ERROR, { variant: "success", text: "Подложка создана", title: "Готово" })
					}
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}	
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_FONMAP_LOADING, false)
			})
		})
	},
	[FONMAP_REMOVE] (context, id) {
		context.commit(SET_FONMAP_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.delete(`manager/fonmaps/${id}`)
			.then(({data}) => {
				if (data) {
					state.fonMaps = state.fonMaps.filter(x => x.id != id)
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Подложка удалена", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_FONMAP_LOADING, false)
			})
		})
	},
	[FONMAPS_LIST_SAVE] (context, params) {
		context.commit(SET_FONMAPS_LIST_LOADING)
		var p = params.map(x => {
			return { id: x.id, orderfm: x.orderfm }
		})
		return new Promise((resolve, reject) => {
			ApiService.put('manager/fonmaps', p)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Порядок подложек на карте сохранен", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_FONMAPS_LIST_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_FONMAPS] (state, data) {
		state.fonMaps = data
		state.fonMapsErrors = []
	},
	[SET_FONMAPS_ERRORS] (state, errors) {
		state.fonMaps = []
		state.fonMapsErrors = errors
	},
	[SET_FONMAPS_LOADING] (state, status = true) {
		state.fonMapsIsLoading = status
	},
	[SET_FONMAP] (state, data) {
		state.fonMap = data
		state.fonMapErrors = []
	},
	[SET_FONMAP_ERRORS] (state, errors) {
		state.fonMap = null
		state.fonMapErrors = errors
	},
	[SET_FONMAP_LOADING] (state, status = true) {
		state.fonMapIsLoading = status
	},
	[SET_FONMAPS_LIST_LOADING] (state, status = true) {
		state.fonMapsListIsLoading = status
	}
}
export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/fonmaps.module.js